import { render, staticRenderFns } from "./UploadDeliveriesFromExel.vue?vue&type=template&id=fb1ed396&scoped=true&lang=pug&"
import script from "./UploadDeliveriesFromExel.vue?vue&type=script&lang=js&"
export * from "./UploadDeliveriesFromExel.vue?vue&type=script&lang=js&"
import style0 from "./UploadDeliveriesFromExel.vue?vue&type=style&index=0&id=fb1ed396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1ed396",
  null
  
)

export default component.exports